import { IconButton } from '@mui/material';
import { Suspense } from 'react';

import { GetWorkOrdersParams } from '../../../api/workOrders/types';
import { SearchField } from '../../../components/UI/SearchField';
import { IconTuneMS } from '../../../constants/icons';
import { lazyWithRetry } from '../../../helpers/lazyWithRetry';

// The filters modal carries the date pickers (~340 KB of source); it loads
// in its own chunk the first time the Home mounts, behind a disabled trigger.
const SearchModal = lazyWithRetry(
  () => import(/* webpackChunkName: "home-search" */ './SearchModal')
);

interface SearchProps {
  searchField: string;
  setSearchField: (value: string) => void;
  setFilters: (value: GetWorkOrdersParams | undefined) => void;
  searchLoading: boolean;
  isFiltersActive: boolean;
}

export function BankSearch({
  searchField,
  setSearchField,
  setFilters,
  searchLoading,
  isFiltersActive,
}: SearchProps): JSX.Element {
  return (
    <SearchField
      value={searchField}
      onChange={setSearchField}
      placeholder="Buscar OS"
      maxLength={11}
      endAdornment={
        <Suspense
          fallback={
            <IconButton size="small" disabled aria-label="filtros">
              {IconTuneMS}
            </IconButton>
          }
        >
          <SearchModal
            setFilters={setFilters}
            searchLoading={searchLoading}
            isFiltersActive={isFiltersActive}
          />
        </Suspense>
      }
    />
  );
}
